export default __webpack_public_path__ + "static/media/tick.a1c1cd1d.svg";